import Vue from "vue";
import Vuex from "vuex";
import store from "./modules/store";
import axios from 'axios'
// import VueAxios from 'vue-axios'
Vue.use(Vuex);
// Vue.use(VueAxios, axios)
const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    store
  },
  strict: debug
});
